
import { Editor } from '@tiptap/vue-2';
import { Component, Emit, Prop, Ref, Vue } from 'nuxt-property-decorator';
import { TiptapMenuButton } from '../../types';
import InputText from '../design-system/input/input-text/InputText.vue';
import TiptapDropdownButton from './TiptapDropdownButton.vue';

@Component({
  components: {
    TiptapDropdownButton,
    InputText,
  },
})
export default class TiptapVideoButton extends Vue {
  @Prop({ required: true }) readonly editor!: Editor;
  @Prop({ required: true }) readonly button!: TiptapMenuButton;
  @Prop({ type: Number, default: 0 }) readonly tabindex!: number;

  @Emit('blur') emitBlur(): void {}

  @Ref() readonly tiptapDropdownButton?: TiptapDropdownButton;
  @Ref() readonly inputText?: InputText;

  public link: string = '';

  public applyLink(): void {
    if (!this.link) return this.clearLink();

    this.editor.chain().focus().extendMarkRange('link').setLink({ href: this.link }).run();
    this.tiptapDropdownButton?.closeMenu();
  }

  public clearLink(): void {
    this.editor.chain().focus().extendMarkRange('link').unsetLink().run();
    this.tiptapDropdownButton?.closeMenu();
  }

  public onShowHandler(): void {
    this.link = this.editor.getAttributes('link').href || '';

    setTimeout(() => {
      this.inputText?.focus();
    }, 125);
  }
}
